document.addEventListener("DOMContentLoaded", function () {
  var giftVariantId = "01807180000"; // <-- DEINE VARIANT ID
  var minAmount = 50.00; // Mindestbetrag in Euro

  // Hole den aktuellen Warenkorbwert
  function getCartTotal(callback) {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        callback(cart.total_price / 100);
      });
  }

  // Füge Geschenk hinzu, dann weiter zum Warenkorb
  function addGiftAndRedirect() {
    fetch("https://free-gift-app.onrender.com/add-gift?gift=" + giftVariantId)
      .then(() => {
        window.location.href = "/cart";
      })
      .catch(() => {
        window.location.href = "/cart";
      });
  }

  // Beim Klick auf Warenkorb prüfen
  document.querySelectorAll('a[href="/cart"]').forEach(el => {
    el.addEventListener("click", function (e) {
      e.preventDefault();
      getCartTotal(function (total) {
        if (total >= minAmount) {
          addGiftAndRedirect();
        } else {
          window.location.href = "/cart";
        }
      });
    });
  });
});